import { api } from './client';

export type NotifKind = 'security' | 'schedule' | 'system';

export interface NotificationPublic {
  id: number;
  type: NotifKind;
  title: string;
  message: string;
  credentialId: number | null;
  isRead: boolean;
  createdAt: number;
}

export interface NotificationsQuery {
  limit?: number;
  before?: number;
  unreadOnly?: boolean;
}

export const notificationsApi = {
  list: (q: NotificationsQuery = {}) => {
    const qs = new URLSearchParams();
    if (q.limit !== undefined) qs.set('limit', String(q.limit));
    if (q.before !== undefined) qs.set('before', String(q.before));
    if (q.unreadOnly) qs.set('unreadOnly', 'true');
    const suffix = qs.toString() ? `?${qs.toString()}` : '';
    return api.get<{ items: NotificationPublic[]; nextBefore: number | null }>(
      `/api/notifications${suffix}`,
    );
  },
  unreadCount: () => api.get<{ count: number }>('/api/notifications/unread-count'),
  markRead: (id: number) => api.post<{ ok: true }>(`/api/notifications/${id}/read`),
  markAllRead: () => api.post<{ ok: true }>('/api/notifications/mark-all-read'),
};
